{
  "pageSize": "1000",
  "idleTabTimeoutMinutes": "30",
  "versionNumber": "10.9.0",
  "healthCheck": {
    "serviceUnavailableContactEmail": "sitesupport@ixico.com",
    "pollingIntervalInSeconds": "60",
    "url": "https://defaultixi-fde-001-gdfmgta0aje5hxer.a01.azurefd.net/ixiprod/healthcheck"
  },
  "appInsightsConnectionString": "InstrumentationKey=42b15f0f-d859-490f-b1fc-ba3091ba4d72;IngestionEndpoint=https://uksouth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uksouth.livediagnostics.monitor.azure.com/;ApplicationId=d6873ed4-7d69-4af5-8fee-0a9ca8464f6c",
  "downloadUserGuideLink": "https://ixicoplc-my.sharepoint.com/personal/nicoletta_vitale_ixico_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fnicoletta%5Fvitale%5Fixico%5Fcom%2FDocuments%2FMicrosoft%20Teams%20Chat%20Files%2FGD%2DSQ%2D000001%20TrialTrackerNx%20Site%20Data%20Management%20User%20Guide%20V%2E3%2Epdf&parent=%2Fpersonal%2Fnicoletta%5Fvitale%5Fixico%5Fcom%2FDocuments%2FMicrosoft%20Teams%20Chat%20Files"
}
